import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

@Injectable()
export class SpinnerService {
  public showSpinner: boolean;
  public loaderStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );
  constructor() {}

  displayLoader(value: boolean) {
    this.loaderStatus.next(value);
    this.showSpinner = value;
  }
}



// WEBPACK FOOTER //
// C:/Users/neenu.korula/AA/eventorg-web/src/app/services/spinner.service.ts